<template>
    <div>
        <div class="cloudPay">
            <p>分类：</p>
            <div style="padding: 10px 0;">
                <AuthChooseItem v-for="(item,index) in $store.state.yunVarity" :key='index'
                :selected='item.id == $route.params.id' 
                :name='item.name' 
                @click="click(item)" />
            </div>
            
        </div>
    </div>
</template>

<script>
    export default {
        name: 'cloadpay',
        methods: {
            click (item) {
                this.$router.push({path: '/Detail/'+item.id})
            }
        }
    }
</script>

<style scoped>
    .cloudPay {
        background: rgb(245, 246, 248);
        padding: 10px;
    }

    .cloudPay p {
        font-size: 12px;
        color: rgb(111, 111, 113);
        clear: both;
    }
</style>